import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";
 const getToken = () => sessionStorage.getItem("ots_token");

// Get single notification
export const getOneNotification = createAsyncThunk(
  "notifications/getOneNotification",
  async ({ notificationId }) => {
    const response = await axios.get(
      `${BASE_URL}/notifications/${notificationId}`
    );
    return response.data;
  }
);

// Mark single notification as read
export const markNotificationRead = createAsyncThunk(
  "notifications/markNotificationRead",
  async ({ notificationId }) => {
    const response = await axios.post(
      `${BASE_URL}/notifications/mark-read/${notificationId}`
    );
    return response.data;
  }
);

// Mark all notifications as read
export const markAllNotificationsRead = createAsyncThunk(
  "notifications/markAllNotificationsRead",
  async ({ userId }) => {
    const response = await axios.post(
      `${BASE_URL}/notifications/mark-all-read/${userId}`
    );
    return response.data;
  }
);

// ✅ Delete notification
export const deleteNotificationThunk = createAsyncThunk(
  "notifications/deleteNotification",
  async ({ notificationId }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/notifications/${notificationId}`,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );
      return { notificationId, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Delete failed");
    }
  }
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    loading: false,
    deletingId: null,
    notificationDetail: null,
    markReadResponse: null,
    markAllReadResponse: null,
    error: "",
  },

  extraReducers: (builder) => {
    builder

      // get single notification
      .addCase(getOneNotification.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOneNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationDetail = action.payload;
      })
      .addCase(getOneNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // mark single notification read
      .addCase(markNotificationRead.pending, (state) => {
        state.loading = true;
      })
      .addCase(markNotificationRead.fulfilled, (state, action) => {
        state.loading = false;
        state.markReadResponse = action.payload;
      })
      .addCase(markNotificationRead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // mark all notifications read
      .addCase(markAllNotificationsRead.pending, (state) => {
        state.loading = true;
      })
      .addCase(markAllNotificationsRead.fulfilled, (state, action) => {
        state.loading = false;
        state.markAllReadResponse = action.payload;
      })
      .addCase(markAllNotificationsRead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // ✅ delete notification
      .addCase(deleteNotificationThunk.pending, (state, action) => {
        state.deletingId = action.meta.arg.notificationId;
      })
      .addCase(deleteNotificationThunk.fulfilled, (state) => {
        state.deletingId = null;
      })
      .addCase(deleteNotificationThunk.rejected, (state, action) => {
        state.deletingId = null;
        state.error = action.payload || action.error.message;
      });
  },
});

export default notificationSlice.reducer;